import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index'
import List from '@/page/list'
import setting from '@/page/setting'
import AnsweredList from '@/page/answeredList'
import Answer from '@/page/answer'
import myAccount from '@/page/myAccount'
import ranking from '@/page/ranking'
import contentList from '@/page/contentList'
import contentDetail from '@/page/contentDetail'
import faq from '@/page/faq'
import privicyPolicy from '@/page/privicyPolicy'
import termsAndCondition from '@/page/termsAndCondition'
import subscribe from '@/page/subscribe'
import Login from '@/page/Login'
import Code from '@/page/code'

Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },{
		path: '/code',
		name: 'code',
		component: Code,
		meta: {
			title: 'code'
		}
    },{
		path: '/setting',
		name: 'setting',
		component: setting,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/list',
		name: 'list',
		component: List,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/answeredList',
		name: 'answeredList',
		component: AnsweredList,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/answer',
		name: 'answer',
		component:Answer,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: myAccount,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/ranking',
		name: 'ranking',
		component: ranking,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/contentList',
		name: 'contentList',
		component: contentList,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/contentDetail',
		name: 'contentDetail',
		component: contentDetail,
		meta: {
			title: 'True or false'
		}
    },{
		path: '/faq',
		name: 'faq',
		component: faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/privicyPolicy',
		name: 'privicyPolicy',
		component: privicyPolicy,
		meta: {
			title: 'Privicy Policy'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: termsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },{
		path: '/subscribe',
		name: 'subscribe',
		component: subscribe,
		meta: {
			title: 'subscribe'
		}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js